module.exports = __webpack_public_path__ + "static/media/team-rocket-intro-1.47aae44f.wav";